import styled from 'styled-components'
import checked from '../../../../assets/svg/checked.svg'

export const MultiselectContainer = styled.div`
  margin-bottom: 20px;
`

export const CheckboxWrapper = styled.label`
  display: flex;
  align-items: center;
  margin-bottom: 5px;
`

export const CheckboxInput = styled.input`
  display: none;
`

export const StyledCheckbox = styled.div<{ isChecked: boolean }>`
  width: 20px;
  height: 20px;
  border: 1px solid #333;
  background-image: ${(props) => (props.isChecked ? `url(${checked})` : 'none')};
  background-color: #fff;
  margin-right: 10px;
  cursor: pointer;
`

export const CheckboxLabel = styled.span`
  cursor: pointer;
`
